/**
 * Formats a note timestamp for display.
 * Example: 'Tuesday, March 4, 2025 at 3:30 PM'. Empty input -> ''.
 */
export const formatNoteDate = (value) => {
    if (!value) return '';
    return new Date(value).toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
};
